import { Link } from "react-router";

interface SiteFooterProps {
  variant: "home" | "clients" | "detailers";
}

export default function SiteFooter({ variant }: SiteFooterProps) {
  const email = variant === "detailers" ? "crew@foundrydetailing.com" : "appointments@foundrydetailing.com";
  const home = variant === "home" ? "" : "/";

  return (
    <footer className="site-foot">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <span className="wordmark" style={{ fontSize: "var(--text-md)" }}>
              Foundry Detailing
            </span>
            <p style={{ marginTop: "var(--space-6)", color: "var(--text-secondary)", maxWidth: "38ch" }}>
              Mobile paint correction and ceramic coating. Ellicott City, Maryland, and 20 miles around it.
            </p>
          </div>
          <div>
            <h4>Site</h4>
            <ul className="foot-list">
              <li>
                <a href={`${home}#services`}>Services</a>
              </li>
              <li>
                <a href={`${home}#process`}>Process</a>
              </li>
              <li>
                <a href={`${home}#work`}>Work</a>
              </li>
              <li>
                <a href={`${home}#pricing`}>Pricing</a>
              </li>
              <li>
                <Link to="/clients">Clients</Link>
              </li>
              {variant === "detailers" && (
                <>
                  <li>
                    <Link to="/detailers">Detailers</Link>
                  </li>
                  <li>
                    <Link to="/portal">Detailer portal</Link>
                  </li>
                </>
              )}
              {variant === "home" && (
                <>
                  <li>
                    <Link to="/detailers">Detailers</Link>
                  </li>
                  <li>
                    <Link to="/portal">Detailer portal</Link>
                  </li>
                  <li>
                    <a href={`${home}#enquire`}>Request an appointment</a>
                  </li>
                </>
              )}
              {variant === "clients" && (
                <li>
                  <a href={`${home}#enquire`}>Request an appointment</a>
                </li>
              )}
            </ul>
          </div>
          <div>
            <h4>Contact</h4>
            <ul className="foot-list">
              <li>
                <a href="tel:+14105550118">(410) 555-0118</a>
              </li>
              <li>
                <a href={`mailto:${email}`}>{email}</a>
              </li>
              <li>Monday to Saturday, 8:00 – 18:00</li>
            </ul>
          </div>
        </div>
        <div className="foot-base">
          <small>© 2026 Foundry Detailing LLC · Licensed and insured</small>
          <small>By appointment only</small>
        </div>
      </div>
    </footer>
  );
}
